###
  For the content engine, slides are configured by first loading the
  config.json file and post-rendering slides. The corresponding views are
  created from templates rather than slide specific views.
###
CommentCollection = require("collections/comments")

{ Sound, Analytics, Session } = Application.actions()

LessonMenuView  = require("views/components/lesson-menu")
SlideAnswerView = require("views/components/slide-answer")
TextInputView   = require("views/components/text-input")
SocialView      = require("views/components/social-learning")
Preloader       = require("lib/preload")
Lesson          = require("models/lesson")
LessonEngine    = require("models/lesson-engine")
processData     = require("lib/data-processer")
I18N            = require("lib/i18n")
device          = require("lib/device")
network_utils   = require("utils/network_utils")

class BaseSlidesView extends Backbone.View
  templates:
    starsAvailable:  require("templates/components/engine/stars-available")
    starsEarned:     require("templates/components/engine/stars-earned")
    slideAnswer:     require("templates/components/engine/slide-answer")

  events:
    "iostap #slide-answer-continue": "onContinue"
    "iostap #lesson-header-nav-menu-btn": "openMenu"
    "iostap #lesson-header-nav-social-learning": "openSocialLearning"
    "iostap #play-audio-popup .btn-yes": "onNarrationAccept"
    "iostap #play-audio-popup .btn-no": "onNarrationReject"

  initialize: (params, callback) ->
    callback()
    @slideSocialComments = []
    @listenTo this, "goToPage", @onGoToPage
    @listenTo this, "showView", @onShowView
    @listenTo Backbone.Events, "subscribe:event:comment-loaded", @onCommentLoad
    @listenTo Backbone.Events, "subscribe:event:goToPage", @goToPage
    @listenTo Backbone.Events, "subscribe:event:toggle-page-count", @toggleHeaderPageCount
    @listenTo Backbone.Events, "subscribe:event:toggle-title", @toggleHeaderTitle
    @listenTo Backbone.Events, "subscribe:event:toggle-nav-btn", @toggleNavBtn
    @listenTo Backbone.Events, "subscribe:event:toggle-open-menu-externally", @toggleOpenMenuExternally
    @listenTo Backbone.Events, "subscribe:event:resume-tracking", @resumeTracking
    @listenTo Backbone.Events, "subscribe:event:pause-tracking", @pauseTracking
    @listenTo Backbone.Events, "application-exit", @onExit
    @listenTo Backbone.Events, "ed-closed", @onDisconnection
    @listenTo Backbone.Events, "load-narration", @onLoadNarration
    @listenTo Backbone.Events, "subscribe:event:new-star", @onNewStar
    @listenTo Backbone.Events, "event:survey-complete", @surveyCompleted

    $(window).bind "unload pagehide", =>
      # closed is Deprecated
      Application.publish("event:lesson-closed") {}
      Application.publish("event:lesson-unload") {}
      @onExit()
      return

    isFullScreen = false

    $(document).on [
      "webkitfullscreenchange"
      "mozfullscreenchange"
      "fullscreenchange"
      "MSFullscreenChange"
    ].join(" "), =>
      isFullScreen =
        document.fullScreen or
        document.mozFullScreen or
        document.webkitIsFullScreen or
        not isFullScreen

      @toggleUI fullscreen: isFullScreen

    if params.cms
      window.ED_LMS_PREVIEW = true
    
    if params.public
      window.ED_PUBLIC_PREVIEW = true

    if params.engine_preview
      window.ENGINE_PREVIEW = true

    if params.cms or params.public
      window.addEventListener "message", (event) =>
        # TODO: check origin for security
        switch event.data.type
          when "go-to-page" then @goToPageFromPreview(event.data.value, event.data.options)
          when "set-current-state" then @setCurrentState(event.data.value)
          when "refresh" then @refresh(event.data.value, event.data.options)
          when "refresh-current-view" then @refreshCurrentView(
            event.data.value,
            event.data.config,
            event.data.slideIndex
          )
    else
      @lesson = new Lesson()
      @lesson.load (err) =>
        if err?
          console.error("Error while loading the lesson data", err)
        else
          renderData = _.extend({}, params, @lesson.getSlides())
          I18N.initialize(renderData.config?.language or "en")
          @initRenderWith(renderData)

  initRenderWith: (data) ->
    @render(data)
    @setElements()
    Preloader.preloadLessonAssets(data.slides)
    Preloader.preloadThomasAssets()

  # on lesson exit.
  # (not to be confused with slide exit/transition @onContinue)
  onExit: ->
    @stopCurrentNarration()
    @stopTracking()
    Application.publish("event:exit") {}
    Application.publish("lesson:exit") {}
    if @options? and @options.scorm and @options.config.hasScormExitButton
      try
        window.top.close()
      catch e
        console.error("error when closing window:", e)

  onDisconnection: ->
    @el.querySelector("#disconnection-warning").classList.add("active")

  refresh: (data, params) ->
    @request?.abort()

    window.clearTimeout @timeout
    delete @currentIndex

    view.undelegateEvents().remove() for view in (@slideViews or [])

    cmsOpts =
      withoutNarration: true
      forceResize: true
      isRefresh: true

    Sound.disableSystemSounds?()
    @lesson = new Lesson(data)
    renderedData = @lesson.getSlides()
    options = _.extend(cmsOpts, renderedData, params)

    I18N.initialize(data?.config?.language or "en")
    @render options
    @setElements()

  setCurrentState: (state) ->
    @getCurrentSlide().setState state

    if state is "complete" and @getCurrentSlide().options.data?.answer?
      @onComplete(@getCurrentSlide(), isCorrect: true)
    else
      @slideAnswerView.toggle(false)

  refreshCurrentView: (options, config, slideIndex) ->
    return if @currentIndex isnt slideIndex
    if @currentIndex?
      view = @getCurrentSlide()
      options.data     = processData.one(options.data, view.options.type, config)
      options.metadata = processData.oneMD(options.metadata)
      if view? and not _.isEqual(options.data, view.options.data)
        @toggleViewInDOM(view, true)
        view.withoutNarration = true
        view.refresh(options, config)

  createSlideViews: (config, params) ->
    (view.off().undelegateEvents() for view in @slideViews) if @slideViews

    @setElements()
    @setGlobalStyles(@options)

    @slideViews =
      for el, i in @el.querySelectorAll(".slide")
        view = @createViewFor(el, @options.slides[i], config, params, i)
        view.on "ui", @toggleUI, this
        view.on "complete", @onComplete, this
        view.on "refresh",  @onRefresh, this
        view.on "scroll",  @onScroll, this
        view.on "video-play", @onVideoPlay, this
        view.on "video-pause", @onVideoPause, this
        view

    @logMenu() if @options.debug

  logMenu: ->
    Logger = new (require "lib/logger")(not window.cordova, "MENU", "#2DB906")

    for el, i in @slideViews
      name = el.options.name
      name += " " while name.length < 22
      Logger "#{name} #{window.location.origin}/#slide/#{i + 1}"

  createViewFor: (el, data, config, params, slideIndex) ->
    View = require("engine/#{data.type}/view")
    v    = new View @optionsForView(el, data, config, params, slideIndex)
    v.lesson = @lesson
    return v

  getExtraConfig: (params) ->
    defaultConfig =
      locked: true
      contextRequiresExitButton: not window.ED_PUBLIC_PREVIEW and
        not params.hideExitButton and
        (not params.scorm or params.config.hasScormExitButton)
      contextAllowsFreeNavigation: not(params.scorm or window.__?.slidedeck?.isScored)
      networkOnline: network_utils.checkOnline()

    config = window.__?.downloadConfiguration


    params.config = _.extend {}, defaultConfig, params.config, config

    params

  # States are UI classes on the view, and can be activated to switch
  # between lesson-wide display modes for stylistic control of all elements,
  # eg. minimal, fullscreen, video-active, flexible-height, text-input.
  toggleUI: (state) ->
    if state.lightbox?
      state.minimal ?= state.lightbox

      @lightboxBgEl.style.backgroundColor =
        if typeof state.lightbox is "string"
          state.lightbox
        else if state.lightbox
          "#111"
        else
          ""

    for key, val of state
      if val?
        @el.classList.toggle("ui-#{written.hyphenCase(key)}", val)

  onVideoPlay: ->
    @toggleUI videoActive: true
    Application.publish("event:video-play") {}

  onVideoPause: ->
    @toggleUI videoActive: false

  toggleStars: (index) ->
    return if not @slideViews[index]? or @options.scorm

    Session.get (err, { stars, alreadyCompleted, enableStars }) =>
      { data, id } = @slideViews[index].options

      # this is to detect whether star progress has been passed in the old
      # emily-sync way (by slide index), or the newer superior hippo-sync way
      # (by slide ID)
      starsKey = if stars and _.find( Object.keys(stars) , ((k) => k.length > 1))
        id
      else
        index

      isQuestionPoolSlide = @slideViews[index].options.metadata.friedrichType is "QuestionPool"

      starOrWeightValue =
        if data?.challenge_configuration?.nb_stars is 0
          0
        else
          data?.challenge_configuration?.nb_stars or
          data?.challenge_configuration?.weighting or
          0

      # enableStars comes from lesson configuration.
      # @options.enableStars comes from Ringo in LMS authoring tool.
      # Depending on where Thomas is being run, one of them is undefined.
      available =
        if not isQuestionPoolSlide and (enableStars or @options.enableStars)
          stars?[starsKey]?.available ? starOrWeightValue
        else
          0
      
      earned = stars?[starsKey]?.earned or 0
      total  = available + earned
      isGame = data?.game?.stars?.min?

      window.clearTimeout @starsTimeout

      if available > 0
        @starsTimeout = window.setTimeout (=>
          @slideStarsEl.innerHTML =
            @templates.starsAvailable { available }

          @slideStarsEl.offsetLeft
          @el.classList.add("display-stars-avail")

          @starsTimeout = window.setTimeout (=>
            @el.classList.remove("display-stars-avail")
          ), 2100
        ), 600

      else
        @el.classList.remove("display-stars-avail")

  calculateDuration: (id) => 
    if @durations?[id]?
      duration = 0
      for details in @durations[id]
        duration += (details.end ? Date.now()) - details.start
      return duration
    else
      return -1

  surveyCompleted: (event) =>
    { slide_id, user_input, attempt } = event
    duration = @calculateDuration(slide_id)
    @lesson.processInteraction
      survey: true
      slide_id:   slide_id
      user_input: user_input
      attempt:    attempt
      duration:   duration

  onComplete: (view, { isCorrect, isTooSlow, answerDetails }) =>
    { name, type, data, id, lessonConfiguration, lessonId, courseId } = view.options

    # calculate total duration
    totalDuration = @calculateDuration(view.id)

    Session.get (err, { attempt }) =>
      @lesson.processInteraction
        lesson_id:     lessonId
        course_id:     courseId
        id:            id
        name:          name
        type:          type
        slideData:     data
        correct:       isCorrect
        tooSlow:       isTooSlow
        answerDetails: answerDetails
        configuration: data.challenge_configuration
        playedSound:   true
        attempt:       attempt
        metadata:      view.options.metadata
        duration:      totalDuration  

      if isCorrect? and lessonConfiguration?.hasAnswerFeedback and data.answer?
        id = if isCorrect then "system:correct" else "system:incorrect"
        Sound.play id

        timerPrompt = data.game?.timer["out-of-time-prompt"]
        if (not timerPrompt) or timerPrompt.trim() is ""
          timerPrompt = i18n("slide-answer.times-up")
        @slideAnswerView.render { isCorrect, isTooSlow, timerPrompt, answer: data.answer }
        @slideAnswerView.toggle(true)

  onRefresh: ->
    @setElements()
    @toggleStars(@scroller.currentPage.pageX)
    @slideAnswerView.toggle(false)

  onContinue: ->
    @slideAnswerView.toggle(false)
    @getCurrentSlide().next()

  openMenu: ->
    if @shouldOpenMenuExternally is true
      Application.publish("event:open-menu") {slideId: @getCurrentSlide().id}
    else
      @lessonMenuView.open()

  openSocialLearning: ->
    Application.publish("event:social-view-clicked") {slideId: @getCurrentSlide().id}
    @socialLearningView.open(@getCurrentSlide(), @slideSocialComments)

  toggleHeaderPageCount: (show) ->
    pageCount = @el.querySelector("#lesson-header-nav-page-count")
    if show is true
      pageCount.style.display = 'inline-block'
    else
      pageCount.style.display = 'none'

  toggleHeaderTitle: (show) ->
    titleContent = @el.querySelector("#lesson-header-title-content")
    if show is true
      titleContent.style.display = 'block'
    else
      titleContent.style.display = 'none'

  toggleNavBtn: (show) ->
    navBtn = @el.querySelector("#lesson-header-nav-menu-btn")
    if show is true
      navBtn.style.display = 'inline-block'
    else
      navBtn.style.display = 'none'

  toggleOpenMenuExternally: (shouldOpen) ->
    @shouldOpenMenuExternally = shouldOpen

  onGoToPage: (index, ms, options = {}) ->
    @slideSocialComments = []
    @setElements() unless @slideStarsEl and @starsAlertEl and @slideAnswerView
    @toggleStars(index)
    @toggleUI(lightbox: false)
    @slideAnswerView.toggle(false)
    @lessonMenuView.setPage(index)
    @socialLearningView.exit()

  onShowView: (slideView) ->
    @socialIconEl?.classList.remove("has-count")
    @startTracking(slideView)
    @playNarration(slideView) if window.location.href.split("thumbnail=true").length isnt 2
    @el.classList.remove("scroll-top", "scroll-bottom", "scroll-middle")

  onScroll: (e, key) ->
    el  = e?.currentTarget
    key ?=
      switch el.scrollTop
        when 0 then "top"
        when el.scrollHeight - el.offsetHeight then "bottom"
        else "middle"

    @el.classList.toggle("scroll-top", key is "top")
    @el.classList.toggle("scroll-bottom", key is "bottom")
    @el.classList.toggle("scroll-middle", key is "middle")

  goToPageFromPreview: (index, options) ->
    @slideViews[index]?.reset()
    @slideViews[index]?.withoutNarration = true

    @goToPage(index, options.ms, { fromPreview: true })

    window.clearTimeout @gotoTimeout
    
    @gotoTimeout = window.setTimeout (=>
      @slideViews[index]?.trigger("resize")
    ), 600

  ## comments: array of comments
  ## total: total number of comments for each slide
  onCommentLoad: ({ comments, total, hasMore }) ->
    @slideSocialComments = comments if comments
    @socialIconEl?.classList.toggle("has-count", total > 0)
    @socialLearningView.updateComments(@slideSocialComments, hasMore) if comments

  onNewStar: ({ earned, total, score }) ->
    window.clearTimeout @starAlertTimeout

    if earned > 0 and score > 0
      @starsAlertEl.classList.add("before-display")
      @starAlertTimeout = window.setTimeout (=>
        @starsAlertEl.innerHTML = @templates.starsEarned
          stars: [0...total].map (el, i) ->
            complete: i < score

        @starsAlertEl.offsetLeft
        @starsAlertEl.classList.add("display")

        @starAlertTimeout = window.setTimeout (=>
          @starsAlertEl.classList.remove("display", "before-display")
        ), 2100

        # optimistically update earned stars so repeating the slide
        # shows an updated available stars message
        Session.get (err, { stars }) =>
          # for backwards compatibility with old learner's app,
          # which sent stars as an array in order of slide index
          if Array.isArray(stars)
            starsForSlide = stars[@currentIndex]
          else
            slideId = @slideViews[@currentIndex]?.id
            starsForSlide = stars[slideId]

          if starsForSlide?
            remainingStars = starsForSlide.available
            starsForSlide.earned = Math.min(starsForSlide.earned + earned, starsForSlide.available)
            starsForSlide.available = Math.max(0, starsForSlide.available - earned)
      ), 300

  onLoadNarration: (isLoading) ->
    @el.classList.toggle "is-loading-narration", isLoading

  setElements: ->
    @slideStarsEl  = @el.querySelector("#stars-available")
    @starsAlertEl  = @el.querySelector("#stars-earned")
    @audioPopupEl  = @el.querySelector("#play-audio-popup")
    @lightboxBgEl  = @el.querySelector("#slides-lightbox-bg")
    @socialIconEl  = @el.querySelector("#lesson-header-nav-social-learning")

    @textInputView?.undelegateEvents()
    @textInputView = new TextInputView(el: "#text-input-view")
    @textInputView.on "open", => @toggleUI textInput: true
    @textInputView.on "exit", => @toggleUI textInput: false

    @socialLearningView?.undelegateEvents()
    @socialLearningView = new SocialView(el: "#social-view")
    @socialLearningView.on "open", =>
      @toggleUI socialLearning: true
      @socialLearningOpen = true
    @socialLearningView.on "exit", =>
      @toggleUI socialLearning: false
      @socialLearningOpen = false

    if device.platform is "iOS"
      # TODO: Better solution that's not as leaky.
      document.addEventListener 'touchmove', (e) =>
        if @socialLearningOpen
          if not $(e.target).parents("#social-view-messages").length
            # user tapped outside the social-learning box. dont scroll.
            e.preventDefault()
          else
            socialMessagesList = document.getElementById("social-view-messages-list")
            if not socialMessagesList or socialMessagesList.scrollHeight <= socialMessagesList.clientHeight
              # social no scrollbar. block scroll
              e.preventDefault()
            # else - social has scrollbar. allow scrolling
      , { passive: false }

    goToPage = (index) =>
      @toggleViewInDOM(@slideViews[index], true)
      @slideViews[index].el.offsetWidth
      @goToPage(index)

    @lessonMenuView?.undelegateEvents()
    @lessonMenuView = new LessonMenuView
      el: @el.querySelector("#lesson-menu")
      back: =>
        goToPage(@currentIndex - 1)
        @trigger('thomas-menu:back')
      restart: =>
        goToPage(0)
        @trigger('thomas-menu:restart')
      exit: =>
        @trigger('thomas-menu:exit')
      scorm: @options.scorm
      isQuiz: @options.config.isQuiz

    @socialLearningView.getCurrentPage = => @currentIndex

    @slideAnswerView?.undelegateEvents()
    @slideAnswerView = new SlideAnswerView
      el: @el.querySelector("#slide-answer")

  setGlobalStyles: (params) ->
    _.extend @options, params

    @setColors()
    @setCustomCSS()
    @setBackgroundImage()
    @initializeHtmlLang()
    @lessonMenuView.updateStyle(@options.config)

  setColors: () ->
    if @options.config?.colors?
      { text, background } = @options.config.colors

      @el.className = @el.className.replace(/theme-[\w-]+/, "")

      if @options.config.colors.theme
        @el.classList.add("theme-#{@options.config.colors.theme.replace(/\s/g,'')}")

      @el.style.color = text
      @el.style.backgroundColor = background
      document.body.style.backgroundColor = background

      isDark = (window.getComputedStyle(@el).color
        .split(/\D+/)
        .filter((e) -> e)
        .slice(0, 3)
        .map(parseFloat)
        .reduce(((m, e) -> m + e / 255), 0)
        ) / 3 < 0.3

      @el.classList.toggle("text-dark", isDark)

  setCustomCSS: ->
    if @options.config?.enableCustomCSS
      css = @options.config?.customCSS
      @el.querySelector("#custom-css")?.innerHTML = css

  setBackgroundImage: () ->
    backgroundEl    = @el.querySelector("#slides-background")
    backgroundImage =
      if @options.config?.background?
        "url(#{@options.config.background})"
      else
        ""

    backgroundEl?.style.backgroundImage = backgroundImage
    document.body.style.backgroundImage = backgroundImage

  initializeHtmlLang: () ->
    # HTML lang attributes let css calculation like `hyphen: auto;` decide the
    # best way to hyphenate based on the language
    document.documentElement.lang = @options.config?.language

  startTracking: (slideView) ->
    # @durations is a dictionary of slides and their timestamps
    # { [slideId: string]: Array<{start: number; end: number; name?: string;}> };
    @durations ?= {}

    @stopTracking()
    Application.publish("event:slide-start") {slideId: slideView.id}
    id = slideView.options?.id
    name =
      slideView.getTrackingTitle() or
      slideView.options?.name

    @durations[id] = [{ start: Date.now(), end: null, name: name }]

  # sets end date to the last timestamp of @durations
  pauseTracking: () -> 
    slideView = @getCurrentSlide()
    timestamps = @durations[slideView.id]
    if timestamps
      timestamps[timestamps.length - 1].end = Date.now()

  # addes a new timestamp to @durations
  resumeTracking: () -> 
    slideView = @getCurrentSlide()
    timestamps = @durations[slideView.id]
    if timestamps
      timestamps.push({ start: Date.now(), end: null, name: name })

  stopTracking: ->
    for id of @durations
      slideName = @durations[id]?[0]?.name
      totalDuration = @calculateDuration(id)
      delete @durations[id]
      Session.get (err, { sessionId }) ->
        Analytics.trackView {
          name: slideName, id: id, duration: totalDuration, session: sessionId
        }

  getCurrentSlide: ->
    @slideViews[@currentIndex]

  stopCurrentNarration: ->
    Sound.stop(@narration) if @narration?

  onNarrationReject: ->
    slideView = @getCurrentSlide()
    @audioPopupEl.classList.remove("active")
    slideView.trigger "narration-complete"
    slideView.setState "prompt"

  onNarrationAccept: ->
    @audioPopupEl.classList.remove("active")
    @playNarration(@getCurrentSlide())

  playNarration: (slideView) ->
    @stopCurrentNarration()
    window.clearTimeout @narrationTimeout

    return if slideView.withoutNarration or @options.withoutNarration

    data = slideView?.serialize()
    wait = 100
    loaded = false

    @narration = data.narration?.audio_file
    if @narration
      Application.publish("event:narration-started")  { 
        can_not_be_skipped: data.narration.can_not_be_skipped 
      }
      if data.narration.can_not_be_skipped
        slideView.setState("narration")
        slideView.trigger("narration-progress", 0)

      @narrationTimeout = window.setTimeout =>
        checkIfSoundHasPlayed = Sound.firstSoundPlayed or (n) -> n(null, true)
        checkIfSoundHasPlayed (err, hasFirstSoundPlayed) =>
          if not hasFirstSoundPlayed
            @audioPopupEl.classList.add("active")
          else
            Sound.play @narration,
              cb: ->
              onProgress: (e) ->
                unless loaded
                  slideView.trigger("narration-loaded", e)
                  loaded = true
                slideView.trigger("narration-progress", e)
              onComplete: ((startingSlide) => (e) =>
                Application.publish("event:narration-completed") { 
                  can_not_be_skipped: data.narration.can_not_be_skipped 
                }
                # only auto-advance on slide narration commenced at.
                if data.narration.progress_on_completion and
                    @getCurrentSlide()?.id is startingSlide?.id
                  slideView.next()
                else
                  slideView.trigger("narration-complete")
                )(@getCurrentSlide())
      , wait

module.exports = BaseSlidesView
